var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-page-header',{staticClass:"pagehead-g",attrs:{"content":"设置新管理员手机号"},on:{"back":_vm.back}}),_c('setphonetool')],1)}
var staticRenderFns = []

export { render, staticRenderFns }